import React, { useState } from "react";
import "./login.scss";

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (!username || !password) {
      setErrorMessage("Please enter username and password.");
      return;
    }

    localStorage.setItem("vendor_token", "demo-token");
    window.location.href = "/vendor";
  };

  return (
    <div className="login-page">
      <div className="login-page__card">
        <div className="login-page__brand"><span>SB</span><strong>SecondBite</strong><small>Vendor Portal</small></div>

        <h1 className="login-page__title">Welcome Back</h1>
        <p className="login-page__subtitle">Login to manage vendors, orders, and reports</p>

        <form className="login-page__form" onSubmit={handleLogin}>
          <div className="login-page__field">
            <span className="login-page__icon">👤</span>
            <input
              className="login-page__input"
              type="text"
              placeholder="Username"
              value={username}
              autoComplete="username"
              onChange={(e) => {
                setUsername(e.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          <div className="login-page__field">
            <span className="login-page__icon">🔒</span>
            <input
              className="login-page__input"
              type="password"
              placeholder="Password"
              value={password}
              autoComplete="current-password"
              onChange={(e) => {
                setPassword(e.target.value);
                setErrorMessage("");
              }}
            />
          </div>

          {errorMessage && (
            <div className="login-page__message login-page__message--error">
              {errorMessage}
            </div>
          )}

          <button type="submit" className="login-page__submit">
            Login
          </button>
        </form>
      </div>

      <div className="login-page__wave login-page__wave--one" />
      <div className="login-page__wave login-page__wave--two" />
    </div>
  );
};

export default LoginPage;